import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import $ from 'jquery';
export default {
  props: {
    showRightAside: {
      type: Boolean,
      default: false
    },
    liveInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    userInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    lockName: {
      type: Boolean,
      default() {
        return false;
      }
    },
    MeInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    talkInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    channel: {
      type: Object,
      default() {
        return {};
      }
    },
    shareInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    rtc: {
      type: Object,
      default() {
        return {};
      }
    },
    degreeHost: {
      type: Object,
      default: function () {
        return {};
      }
    },
    isAudioLevel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lowNetworkTime: 0,
      lowNetwork: false,
      initAudioOnlyPopup: true,
      questionerStream: {},
      dealInterviewerHasUnsubscribe: false,
      dealShareHasUnsubscribe: false,
      dealQuestionHasUnsubscribe: false,
      noCameras: false,
      questionList: [],
      nameList: {},
      organizationList: {},
      isAllScreen: false,
      setNameInfo: {
        show: false
      },
      voiceList: {}
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      logoGray: state => state.logoGray
    }),
    userId() {
      return this.userInfo.rtilCode;
    },
    managerRtil() {
      return this.userInfo.status ? this.userInfo.status.managerRtil : '';
    },
    questionSpeakerInfo() {
      return this.channel[this.userInfo.status.questionSpeaker] || {};
    },
    shareList() {
      return this.channel[this.shareInfo.rtilCode] || {};
    },
    operateList() {
      const obj = {};
      let array = [];
      this.questionList.forEach((v, index) => {
        array = ['setPublicTalk', 'cancelQuestionerRemove'];
        if (index > 0) {
          array.unshift('toTop');
        }
        obj[v.rtilCode] = array;
      });
      return obj;
    },
    returnVideoClass() {
      let _str = '';
      if (this.degreeHost[this.MeInfo.id] == 0) {
        _str += 'rotate0';
      } else if (this.degreeHost[this.MeInfo.id] == 90) {
        _str += 'rotate90';
      } else if (this.degreeHost[this.MeInfo.id] == 180) {
        _str += 'rotate180';
      } else if (this.degreeHost[this.MeInfo.id] == 270) {
        _str += 'rotate270';
      }
      return _str;
    }
  },
  created() {
    window.addEventListener('resize', this.setVideoWidths);
    this.$nextTick(() => {
      this.setVideoWidths();
    });
    Bus.$on('volumeList', volumeList => {
      volumeList.forEach((volume, index) => {
        this.$set(this.voiceList, volume.uid, volume);
      });
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          this.$set(this.nameList, val.mark, val.value);
        }
        if (val.key == 'organization') {
          this.$set(this.organizationList, val.mark, val.value);
        }
      });
    });
    // 移除questioner
    Bus.$on('cancelQuestioner', result => {
      this.questionList.forEach((v, k) => {
        if (v.rtilCode == result.rtilCode) {
          this.questionList.splice(k, 1);
        }
      });
    });
    // 添加questioner
    Bus.$on('setQuestioner', result => {
      // 控制连续点击发多个命令导致数据重复问题
      if (!this.questionList.map(v => v.rtilCode).includes(result.rtilCode) && result.rtilCode) {
        this.questionList.push(result);
      }
      this.getNickName([result.rtilCode]);
    });
    Bus.$on('setQuestionSpeaker', result => {
      this.questionList.forEach((v, k) => {
        if (v.rtilCode == result.rtilCode) {
          this.questionList.splice(k, 1);
        }
      });
    });
    Bus.$on('checkAll', () => {
      this.isAllScreen = !this.isAllScreen;
    });
    Bus.$on('cancelScreen', () => {
      this.isAllScreen = false;
    });
    Bus.$on('questionerList', v => {
      this.questionList = v.questionerList || [];
    });
    const nameIdList = [this.userInfo.rtilCode];
    if (this.userInfo.status.questionSpeaker) nameIdList.push(this.userInfo.status.questionSpeaker);
    this.getNickName(nameIdList);
    this.getQuestionList();
    // 处理初始化及其他 audio-only 时的视频订阅问题
    Bus.$on('setSubscribeTrack', payload => {
      this.questionSpeakerInfo.id = this.userInfo.status.questionSpeaker;
      this.shareList.id = this.shareInfo.rtilCode;
      // 获取channel的值
      this.$set(this.channel, payload.id, {
        ...payload,
        info: {
          rtilCode: payload.id
        }
      });
      if (payload.id == this.userInfo.rtilCode) return;
      // 提问者
      if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && this.questionSpeakerInfo.id == payload.id) {
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            this.rtc.subscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback');
            this.questionSpeakerInfo.hasUnsubscribe = false;
            this.dealInterviewerHasUnsubscribe = this.questionSpeakerInfo.hasUnsubscribe;
          } else {
            this.rtc.unsubscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback');
            this.questionSpeakerInfo.hasUnsubscribe = true;
            this.dealInterviewerHasUnsubscribe = this.questionSpeakerInfo.hasUnsubscribe;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            this.questionSpeakerInfo.hasUnsubscribe = true;
            this.dealInterviewerHasUnsubscribe = this.questionSpeakerInfo.hasUnsubscribe;
          } else {
            this.rtc.subscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback');
            this.questionSpeakerInfo.hasUnsubscribe = false;
            this.dealInterviewerHasUnsubscribe = this.questionSpeakerInfo.hasUnsubscribe;
          }
        }
        this.$emit('dealSpeakHasUnsubscribe', {
          dealInterviewerHasUnsubscribe: this.dealInterviewerHasUnsubscribe
        });
        return;
      }
      // 分享屏幕
      if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id == payload.id) {
        if (this.State.audioType) {
          if (this.State.audioType == 2 || this.State.checkShareScreen) {
            this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
            this.dealShareHasUnsubscribe = this.shareList.hasUnsubscribe;
          } else {
            this.rtc.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = true;
            this.dealShareHasUnsubscribe = this.shareList.hasUnsubscribe;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkShareScreen) {
              this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = false;
              this.dealShareHasUnsubscribe = this.shareList.hasUnsubscribe;
            } else {
              this.shareList.hasUnsubscribe = true;
              this.dealShareHasUnsubscribe = this.shareList.hasUnsubscribe;
            }
          } else {
            this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
            this.dealShareHasUnsubscribe = this.shareList.hasUnsubscribe;
          }
        }
        this.$emit('dealSpeakShareHasUnsubscribe', {
          dealShareHasUnsubscribe: this.dealShareHasUnsubscribe
        });
        return;
      }
      // 采访者队列
      Object.keys(this.questionList).forEach(id => {
        if (this.questionList[id].rtilCode != this.userInfo.rtilCode) {
          if (this.questionList[id].rtilCode == payload.id) {
            if (this.State.audioType == 1) {
              this.$set(this.questionerStream, this.questionList[id].rtilCode, {
                id: this.questionList[id].rtilCode,
                hasUnsubscribe: true
              });
            } else {
              this.rtc.subscribe(this.questionList[id].rtilCode, 'video', 'unExecuteCallback');
              this.$set(this.questionerStream, this.questionList[id].rtilCode, {
                id: this.questionList[id].rtilCode,
                hasUnsubscribe: false
              });
            }
          }
        }
      });
    });
    // audioOnly选择器
    Bus.$on('subscribeAudioControl', val => {
      if (val) {
        // 2 禁用
        if (val == 2) {
          // 提问者
          if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && this.questionSpeakerInfo.hasUnsubscribe && this.questionSpeakerInfo) {
            this.rtc.subscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback');
            this.questionSpeakerInfo.hasUnsubscribe = false;
            this.$emit('dealSpeakHasUnsubscribe', {
              dealInterviewerHasUnsubscribe: this.questionSpeakerInfo.hasUnsubscribe
            });
          }
          if (this.shareList.id != this.userInfo.rtilCode && this.shareList.hasUnsubscribe && this.shareList) {
            // 分享屏幕
            this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
            this.$emit('dealSpeakShareHasUnsubscribe', {
              dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
            });
          }
          // 采访者队列
          Object.keys(this.questionerStream).forEach(id => {
            if (this.questionerStream[id].id) {
              this.rtc.subscribe(this.questionerStream[id].id, 'video', 'unExecuteCallback');
              this.questionerStream[id].hasUnsubscribe = false;
            }
          });
          return; // 2 是关闭 audio-only 状态不用订阅
        }
        // 1 allTheTime
        // 提问者
        if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && !this.questionSpeakerInfo.hasUnsubscribe && this.questionSpeakerInfo.id) {
          // 需要判断当前的 mainWindow是否处于选中状态，选中需要订阅
          this.rtc.unsubscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback');
          this.questionSpeakerInfo.hasUnsubscribe = true;
          this.$emit('dealSpeakHasUnsubscribe', {
            dealInterviewerHasUnsubscribe: this.questionSpeakerInfo.hasUnsubscribe
          });
        }
        if (this.shareList.id != this.userInfo.rtilCode && !this.shareList.hasUnsubscribe && this.shareList.id) {
          // 分享屏幕
          if (!this.State.checkShareScreen) {
            this.rtc.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = true;
          }
          this.$emit('dealSpeakShareHasUnsubscribe', {
            dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
          });
        }
        // 采访者队列
        Object.keys(this.questionerStream).forEach(id => {
          if (this.questionerStream[id].id) {
            this.rtc.unsubscribe(this.questionerStream[id].id, 'video', 'unExecuteCallback');
            this.questionerStream[id].hasUnsubscribe = true;
          }
        });
      } else {
        // 0 自动
        // 提问者
        if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && this.questionSpeakerInfo.hasUnsubscribe && this.questionSpeakerInfo) {
          // 需要判断当前的 mainWindow是否处于选中状态，选中需要订阅
          // 分为两种情况一种网络较好(可以不取参考checkbox)，另外一种是网络不好需要参考checkbox
          if (!this.State.inAudioOnlyStatus) {
            this.rtc.subscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback');
            this.questionSpeakerInfo.hasUnsubscribe = false;
          } else {
            this.rtc.subscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback');
            this.questionSpeakerInfo.hasUnsubscribe = false;
          }
          this.$emit('dealSpeakHasUnsubscribe', {
            dealInterviewerHasUnsubscribe: this.questionSpeakerInfo.hasUnsubscribe
          });
        }
        if (this.shareList.id != this.userInfo.rtilCode && this.shareList.hasUnsubscribe && this.shareList) {
          // 分享屏幕
          if (!this.State.inAudioOnlyStatus) {
            this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
          } else {
            if (this.State.checkShareScreen) {
              this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = false;
            }
          }
          this.$emit('dealSpeakShareHasUnsubscribe', {
            dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
          });
        }
        // 采访者队列
        Object.keys(this.questionerStream).forEach(id => {
          if (this.questionerStream[id].id) {
            this.rtc.subscribe(this.questionerStream[id].id, 'video', 'unExecuteCallback');
            this.questionerStream[id].hasUnsubscribe = false;
          }
        });
      }
    });
    // mainWindow 勾选
    // Bus.$on('dealMainAudioOnly', val => {
    //   // 先判断当前处于哪种模式下
    //   if (this.State.audioType) {
    //     // 2
    //     if (this.State.audioType == 2) {
    //       if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && this.questionSpeakerInfo.id) {
    //         // 提问者
    //         this.rtc.subscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback')
    //         this.questionSpeakerInfo.hasUnsubscribe = false
    //         this.$emit('dealSpeakHasUnsubscribe', {
    //           dealInterviewerHasUnsubscribe: this.questionSpeakerInfo.hasUnsubscribe
    //         })
    //       }
    //       if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id) {
    //         // 分享屏幕
    //         this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback')
    //         this.shareList.hasUnsubscribe = false
    //         this.$emit('dealSpeakShareHasUnsubscribe', {
    //           dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
    //         })
    //       }
    //     } else {
    //       // 1
    //       if (val) {
    //         if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && this.questionSpeakerInfo.id) {
    //           this.rtc.subscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback')
    //           this.questionSpeakerInfo.hasUnsubscribe = false
    //           this.$emit('dealSpeakHasUnsubscribe', {
    //             dealInterviewerHasUnsubscribe: this.questionSpeakerInfo.hasUnsubscribe
    //           })
    //         }
    //         if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id) {
    //           this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback')
    //           this.shareList.hasUnsubscribe = false
    //           this.$emit('dealSpeakShareHasUnsubscribe', {
    //             dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
    //           })
    //         }
    //       } else {
    //         if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && this.questionSpeakerInfo.id) {
    //           this.rtc.unsubscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback')
    //           this.questionSpeakerInfo.hasUnsubscribe = true
    //           this.$emit('dealSpeakHasUnsubscribe', {
    //             dealInterviewerHasUnsubscribe: this.questionSpeakerInfo.hasUnsubscribe
    //           })
    //         }
    //         if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id) {
    //           if (this.State.checkShareScreen) return
    //           this.rtc.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback')
    //           this.shareList.hasUnsubscribe = true
    //           this.$emit('dealSpeakShareHasUnsubscribe', {
    //             dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
    //           })
    //         }
    //       }
    //     }
    //     // 0
    //   } else {
    //     // 如果是 auto audio-only 需要先判断当前是否处于 audio-only 状态中
    //     if (!this.State.inAudioOnlyStatus) {
    //       if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && this.questionSpeakerInfo.id) {
    //         this.rtc.subscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback')
    //         this.questionSpeakerInfo.hasUnsubscribe = false
    //         this.$emit('dealSpeakHasUnsubscribe', {
    //           dealInterviewerHasUnsubscribe: this.questionSpeakerInfo.hasUnsubscribe
    //         })
    //       }
    //       if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id) {
    //         // 分享屏幕
    //         this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback')
    //         this.shareList.hasUnsubscribe = false
    //         this.$emit('dealSpeakShareHasUnsubscribe', {
    //           dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
    //         })
    //       }
    //     } else {
    //       if (val) {
    //         if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && this.questionSpeakerInfo.id) {
    //           this.rtc.subscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback')
    //           this.questionSpeakerInfo.hasUnsubscribe = false
    //           this.$emit('dealSpeakHasUnsubscribe', {
    //             dealInterviewerHasUnsubscribe: this.questionSpeakerInfo.hasUnsubscribe
    //           })
    //         }
    //         if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id) {
    //           this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback')
    //           this.shareList.hasUnsubscribe = false
    //           this.$emit('dealSpeakShareHasUnsubscribe', {
    //             dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
    //           })
    //         }
    //       } else {
    //         if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && this.questionSpeakerInfo.id) {
    //           this.rtc.unsubscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback')
    //           this.questionSpeakerInfo.hasUnsubscribe = true
    //           this.$emit('dealSpeakShareHasUnsubscribe', {
    //             dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
    //           })
    //         }
    //         if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id) {
    //           this.rtc.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback')
    //           this.shareList.hasUnsubscribe = true
    //           this.$emit('dealSpeakShareHasUnsubscribe', {
    //             dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
    //           })
    //         }
    //       }
    //     }
    //   }
    // })
    // shareScreen 勾选
    Bus.$on('dealShareAudioOnly', val => {
      if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id) {
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
            this.$emit('dealSpeakShareHasUnsubscribe', {
              dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
            });
          } else {
            if (val) {
              this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = false;
              this.$emit('dealSpeakShareHasUnsubscribe', {
                dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
              });
            } else {
              this.rtc.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = true;
              this.$emit('dealSpeakShareHasUnsubscribe', {
                dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
              });
            }
          }
        } else {
          if (!this.State.inAudioOnlyStatus) {
            this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
            this.$emit('dealSpeakShareHasUnsubscribe', {
              dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
            });
          } else {
            if (val) {
              this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = false;
              this.$emit('dealSpeakShareHasUnsubscribe', {
                dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
              });
            } else {
              this.rtc.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback');
              this.shareList.hasUnsubscribe = true;
              this.$emit('dealSpeakShareHasUnsubscribe', {
                dealShareHasUnsubscribe: this.shareList.hasUnsubscribe
              });
            }
          }
        }
      }
    });
    // audioOnly自动网络质量变化的情况下
    Bus.$on('downlinkNetworkQuality', val => {
      // 判断当前所选择的 audio-only 模式，如果是 all time 的话则不需要走这段逻辑
      if (this.State.audioType || this.State.audioType == 2) return;
      // 当连续8s处于若网时，则改为只订阅音频流,连续6s状态良好则恢复订阅视频流
      if (val < 4) {
        if (this.lowNetworkTime > 0) {
          this.lowNetworkTime--;
        } else {
          this.lowNetworkTime = 0;
        }
        if (this.lowNetwork && this.lowNetworkTime === 0) {
          this.lowNetwork = false;
          if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && this.questionSpeakerInfo.id && this.questionSpeakerInfo.hasUnsubscribe) {
            // 提问者
            this.rtc.subscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback');
            this.questionSpeakerInfo.hasUnsubscribe = false;
          }
          if (this.shareList.id != this.userInfo.rtilCode && this.shareList.id && this.shareList.hasUnsubscribe) {
            // 分享屏幕
            this.rtc.subscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = false;
          }
          // 采访者队列
          Object.keys(this.questionerStream).forEach(id => {
            if (this.questionerStream[id].id) {
              this.rtc.subscribe(this.questionerStream[id].id, 'video', 'unExecuteCallback');
              this.questionerStream[id].hasUnsubscribe = false;
            }
          });
          this.State.inAudioOnlyStatus = false;
          this.initAudioOnlyPopup = true;
        }
      } else {
        if (this.lowNetworkTime < 3) {
          this.lowNetworkTime++;
        } else if (this.lowNetworkTime === 3) {
          this.lowNetwork = true;
        }
        if (this.lowNetwork) {
          if (this.questionSpeakerInfo.id != this.userInfo.rtilCode && this.questionSpeakerInfo.id && !this.questionSpeakerInfo.hasUnsubscribe) {
            this.rtc.unsubscribe(this.questionSpeakerInfo.id, 'video', 'unExecuteCallback');
            this.questionSpeakerInfo.hasUnsubscribe = true;
          }
          if (!this.State.checkShareScreen && this.shareList.id != this.userInfo.rtilCode && this.shareList.id && !this.shareList.hasUnsubscribe) {
            this.rtc.unsubscribe(this.shareList.id, 'video', 'unExecuteCallback');
            this.shareList.hasUnsubscribe = true;
          }
          // 采访者队列
          Object.keys(this.questionerStream).forEach(id => {
            if (this.questionerStream[id].id) {
              this.rtc.unsubscribe(this.questionerStream[id].id, 'video', 'unExecuteCallback');
              this.questionerStream[id].hasUnsubscribe = true;
            }
          });
          this.State.inAudioOnlyStatus = true;
          if (this.initAudioOnlyPopup) {
            this.initAudioOnlyPopup = false;
            this.$message.success(this.$t('netWorkStatus.poorNetworkPopup'));
          }
        }
      }
    });
  },
  methods: {
    hasChangeMic() {
      this.$refs.localVideo.reAddAudioContext();
    },
    setSpeakerUser() {
      if (this.userInfo.rtilCode != this.questionSpeakerInfo.id) {
        var _this$$refs$talkInfoV;
        (_this$$refs$talkInfoV = this.$refs.talkInfoVideo) === null || _this$$refs$talkInfoV === void 0 ? void 0 : _this$$refs$talkInfoV.setSpeakerAttendUser();
      }
      if (this.$refs.shareStreamBox) {
        var _this$$refs$shareStre;
        (_this$$refs$shareStre = this.$refs.shareStreamBox) === null || _this$$refs$shareStre === void 0 ? void 0 : _this$$refs$shareStre.setSpeakerAttendUser();
      }
    },
    returnStream(item) {
      // :singChannel="questionList[index-1] && channel[questionList[index-1].rtilCode] ? channel[questionList[index-1].rtilCode] : {}"
      let stream = {};
      if (item && this.channel[item.rtilCode]) {
        Object.keys(this.questionerStream).forEach(id => {
          if (item.rtilCode == this.questionerStream[id].id) {
            this.channel[item.rtilCode].hasUnsubscribe = this.questionerStream[id].hasUnsubscribe;
          }
        });
        stream = this.channel[item.rtilCode];
      }
      return stream;
    },
    attendCallback(obj) {
      const {
        type,
        rtilCode,
        val
      } = obj;
      let index = 0;
      this.questionList.forEach((v, key) => {
        if (v.rtilCode == rtilCode) {
          index = key;
        }
      });
      if (type == 'setPublicTalk') {
        this.setOperate('talk', index);
      } else if (type == 'cancelQuestionerRemove') {
        this.setOperate('remove', index);
      } else if (type == 'toTop') {
        this.changeToTop(rtilCode);
      } else if (type == 'cancelQuestionSpeaker' || type == 'hangUpInterview') {
        this.setOperate('space', 0);
      } else if (type == 'muteAudio' || type == 'muteVideo') {
        this.$emit('callback', obj);
      } else if (type === 'fullScreen') {
        this.State.fullScreen = val;
        if (val) {
          this.$emit('callback', {
            type: 'fullScreen',
            val
          });
        }
      } else if (type === 'audioContext') {
        this.$emit('callback', {
          type: 'audioContext',
          val
        });
      }
    },
    changeToTop(rtilCode) {
      const params = {
        conferenceCode: this.$route.query.id,
        rtilCode: rtilCode
      };
      this.axios.post(`/partyline-backend/conference/noLogin/toTop/${this.State.partyCode}/${rtilCode}`, params);
    },
    checkScreen() {
      this.isAllScreen = false;
    },
    setVideoWidths() {
      const widthRem = 16 / 9;
      if ($('.speaker')) {
        const height = $('.speaker').height();
        let width = height * widthRem * 2 + 10;
        if (width > window.innerWidth) width = window.innerWidth;
        $('.speaker').css({
          'max-width': width
        });
      }
      if ($('.videos')) {
        const height = ($('.reporter').height() - 10) / 2;
        const videoWidth = height * widthRem;
        $('.reporter').css({
          'max-width': videoWidth * 4
        });
      }
    },
    getQuestionList() {
      this.axios.get(`/partyline-backend/conference/noLogin/questionerList/${this.$route.query.id}`).then(res => {
        if (res.data.errorCode == '0x0') {
          this.questionList = res.data.result || [];
          this.getNickName(this.questionList.map(v => v.rtilCode));
        }
      });
    },
    async getNickName(nameIdList) {
      if (!nameIdList || !nameIdList.length || !this.$route.query.id) return;
      await this.axios.post('/partyline-backend/behavior/noLogin/getList', {
        annotation: this.$route.query.id,
        keys: ['nickName', 'organization'],
        marks: nameIdList.constructor == Array ? nameIdList : [nameIdList]
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          Object.keys(result).forEach(key => {
            this.$set(this.nameList, key, result[key].nickName);
            this.$set(this.organizationList, key, result[key].organization);
          });
        }
      });
    },
    async setOperate(type, index) {
      const rtilCode = this.questionList[index] ? this.questionList[index].rtilCode : '';
      const params = {
        partyCode: this.$route.query.id,
        module: '',
        msg: {
          rtilCode: '',
          nickName: this.nameList[rtilCode],
          organization: this.organizationList[rtilCode]
        }
      };
      if (type == 'space') {
        // 升级至questionSpeaker
        const questionSpeaker = this.userInfo.status.questionSpeaker;
        if (questionSpeaker) {
          // 移除当前questionSpeaker
          const data = JSON.parse(JSON.stringify(params));
          data.msg.rtilCode = questionSpeaker;
          data.module = 'cancelQuestionSpeaker';
          data.nickName = this.nameList[questionSpeaker];
          data.organization = this.organizationList[questionSpeaker];
          this.userInfo.status.questionSpeaker = '';
          await this.commandOperate(data);
        } else {
          if (!this.questionList.length) return;
          params.module = 'setQuestionSpeaker';
          params.msg.rtilCode = rtilCode;
          this.userInfo.status.questionSpeaker = this.questionList[index].rtilCode;
          this.questionList.splice(index, 1);
          this.commandOperate(params);
        }
      }
      if (type == 'talk') {
        // 升级至questionSpeaker
        const questionSpeaker = this.userInfo.status.questionSpeaker;
        if (questionSpeaker) {
          // 移除当前questionSpeaker
          const data = JSON.parse(JSON.stringify(params));
          data.msg.rtilCode = questionSpeaker;
          data.module = 'cancelQuestionSpeaker';
          data.nickName = this.nameList[questionSpeaker];
          data.organization = this.organizationList[questionSpeaker];
          this.userInfo.status.questionSpeaker = '';
          await this.commandOperate(data);
        }
        if (!this.questionList.length) return;
        params.module = 'setQuestionSpeaker';
        params.msg.rtilCode = rtilCode;
        this.userInfo.status.questionSpeaker = this.questionList[index].rtilCode;
        this.questionList.splice(index, 1);
        this.commandOperate(params);
      }
      if (type == 'remove') {
        // 降级至reporter
        params.module = 'cancelQuestioner';
        params.msg.rtilCode = rtilCode;
        this.questionList.splice(index, 1);
        this.commandOperate(params);
      }
    },
    async commandOperate(params) {
      await this.axios.post('/partyline-backend/party/noLogin/command?key=50559', params);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setVideoWidths);
  }
};